import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: theme.spacing(1.5),
  },
  subheader: {
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(8),
  },
  body: {
    marginBottom: theme.spacing(2),
  },
  email: {
    color: theme.palette.primary.main,
  },
  resendEmailButton: {
    minWidth: theme.spacing(15),
  },
}));

export default useStyles;
